import { message } from 'antd';

export interface IMessageGlobalConfigurationProps {
  /**
   * Configura la distanza dal margine superiore del container dei messaggi.
   */
  top?: number;
}

/**
 * Richiama la configurazione globale per i message di antd per impostare
 * il tempo di visualizzazione dei messaggi.
 * Imposta inoltre il container per i messaggi per soddisfare l'accessibilità.
 */
export function MessageGlobalConfiguration(
  props: IMessageGlobalConfigurationProps,
) {
  const { top } = props;
  message.config({
    duration: 5,
    // Di default la spostiamo dall'header di 70px. per evitare che
    // il messaggio nasconda il menu di navigazione.
    top: top ?? 70,
    getContainer: () => document.getElementById('root-messages')!,
  });

  return <div id="root-messages" role="alert" />;
}
